import * as immutable from "immutable";
import { UserAutocompleteItem } from "../../service/api-response/UsersAutocompleteSuccessResponse";
import * as authSelectors from "../auth/authSelectors";
import { RootState } from "../../store";
import * as _ from "lodash";

export const userList = (state: RootState) => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return undefined;
  }

  return org.get("users", immutable.List());
};

export const userListTotalCount = (state: RootState) => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return undefined;
  }

  return org.get("usersTotal", 0);
};

export const nextPageUrl = (state: RootState): string | undefined => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return "";
  }

  return org.get("nextPageUrl", undefined);
};

export const hasNextPage = (state: RootState): boolean => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return false;
  }

  return org.get("hasMore", false);
};

export const filters = (
  state: RootState
): { [k: string]: string | number | boolean } | undefined => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return undefined;
  }

  return org.get("filters", {}).toJS() as any;
};

export const hasFilters = (state: RootState): boolean => {
  const filterValues = filters(state);

  return !!filterValues && !_.isEmpty(filterValues);
};

export const isLoadingUsers = (state: RootState): boolean => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return false;
  }

  return org.get("isLoadingUsers", false);
};

export const isApprovingUser = (state: RootState, userId: number): boolean => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return false;
  }

  return org.get("isApprovingUser", {})[userId];
};

export const isDenyingUser = (state: RootState, userId: number): boolean => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);
  const org = state.user.orgMap.get(orgKeyName);

  if (!org) {
    return false;
  }

  return org.get("isDenyingUser", {})[userId];
};

export const isLoadingAutocomplete = (state: RootState): boolean => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);

  const org = state.user.orgMap.get(orgKeyName);
  if (!org) {
    return false;
  }

  return org.get("isLoadingAutocomplete", false);
};

export const autocompleteUsers = (state: RootState): UserAutocompleteItem[] => {
  const orgKeyName = authSelectors.selectedOrganizationKeyName(state);

  const org = state.user.orgMap.get(orgKeyName);
  if (!org) {
    return [];
  }

  return org.get("autocompleteUsers", []);
};
